import format from '_shared_/plugins/format';

const mutations = {
  SET_QUARTERLY_HOLDINGS(state, payload) {
    const result = {
      holdingsMetaData: {},
      holdings: []
    };
    result.holdingsMetaData = payload.holdings;
    for (let i = 0; i < payload.holdingsData.length; i++) {
      result.holdings.push(Object.assign({},
        payload.holdingsData[i],
        {
          _holdingsName: format.formatHelpers.string(payload.holdingsData[i].holdingName),
          _assetType: format.formatHelpers.string(payload.holdingsData[i].assetType),
          _shares: format.formatHelpers.number(payload.holdingsData[i].shares),
          _marketValue: format.formatHelpers.price(payload.holdingsData[i].marketValue),
          _pctNetAssets: format.formatHelpers.rawPercent(payload.holdingsData[i].pctNetAssets),
          _holdingQuotronSymbol: format.formatHelpers.string(payload.holdingsData[i].holdingQuotronSymbol),
          _containsHoldings: format.formatHelpers.number(payload.holdingsData[i].containsHoldings),
          _holdingClassSymbol: format.formatHelpers.string(payload.holdingsData[i].holdingClassSymbol),
          _holdingURLName: format.formatHelpers.string(payload.holdingsData[i].holdingURLName)
        }
      ));
    }
    state.quarterlyHoldingsData = result.holdings;
    state.quarterlyHoldingsMetaData = result.holdingsMetaData;
  }
};
const getters = {
  getQuarterlyHoldingsData: state => state.quarterlyHoldingsData,
  getQuarterlyHoldingsMetaData: state => state.quarterlyHoldingsMetaData
};
const state = {
  quarterlyHoldingsData: {},
  quarterlyHoldingsMetaData: {}
};

export default {
  state,
  getters,
  mutations
};
